// extracted by mini-css-extract-plugin
export var attachment = "_q5-a";
export var emailContainer = "_q5-4";
export var emailContentPaddedContainer = "_q5-b";
export var emailHeader = "_q5-6";
export var emailIframe = "_q5-3";
export var emailInfoIcon = "_q5-9";
export var emailShortenedSummary = "_q5-e";
export var infoDropdown = "_q5-0";
export var infoRowBoundedContent = "_q5-d";
export var internal = "_q5-5";
export var merchant = "_q5-8";
export var messageInputContainer = "_q5-h";
export var normal = "_q5-7";
export var replyCard = "_q5-f";
export var subtleButton = "_q5-1";
export var subtleButtonIconContainer = "_q5-2";
export var toggleViewRepliesButton = "_q5-c";
export var wrappingText = "_q5-g";